import { Flex } from 'antd';
import styled from 'styled-components';

export const SLogoWrapper = styled(Flex)`
  cursor: pointer;
  height: 85px;
`;

export const SLogoText = styled.span`
  font-size: 20px;
  font-weight: 500;
  line-height: 1.3;
`;

export const SIdentity = styled.span`
  font-size: 14px;
  color: rgba(102, 112, 133, 0.9);
  line-height: 1.3;
`;
